import { WizardStateType } from "./types/WizardStateType";

export const initialState: WizardStateType = {
	wizardUrl: "",
	wizardRequested: false,
};
